var _path, _path2, _path3, _path4, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallengesub1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 90,
    viewBox: "0 0 83 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5089 33.2447C50.5971 33.2447 62.0179 28.7128 62.0179 23.1224C62.0179 17.5319 50.5971 13 36.5089 13C22.4207 13 11 17.5319 11 23.1224C11 28.7128 22.4207 33.2447 36.5089 33.2447Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23.1223V65.0579C11 70.8421 22.1602 75.6622 36.5089 75.6622M62.0179 23.1223V50.1153M11 39.0289C11 44.8131 22.1602 49.6333 36.5089 49.6333C47.1376 49.6333 56.1721 46.7412 59.8921 42.885M11 54.4535C11 60.2377 22.1602 65.0579 36.5089 65.0579",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0053 87.9691C71.0148 87.9691 79.9398 79.874 79.9398 69.8883C79.9398 59.9025 71.0148 51.8075 60.0053 51.8075C48.9958 51.8075 40.0708 59.9025 40.0708 69.8883C40.0708 79.874 48.9958 87.9691 60.0053 87.9691Z",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7676 59.7455L60.0055 70.5562M60.0055 70.5562L69.2435 59.7455M60.0055 70.5562V82.6772M52.6152 72.8493H67.3959M52.6152 77.7633H67.3959",
    stroke: "#FF6000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.82843,
    y1: 2,
    x2: 81,
    y2: 80.1716,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 112.551,
    y2: -2,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0 83)",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesub1);
export default __webpack_public_path__ + "static/media/challengesub1.bfca7bcdb4b5b1c73e7cc1bd6ee95f3d.svg";
export { ForwardRef as ReactComponent };